import { render, staticRenderFns } from "./CountryFlagSelect.vue?vue&type=template&id=4bcade0f&"
import script from "./CountryFlagSelect.vue?vue&type=script&lang=js&"
export * from "./CountryFlagSelect.vue?vue&type=script&lang=js&"
import style0 from "./CountryFlagSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports